// extracted by mini-css-extract-plugin
export default {"container":"FormErrorDisplay_container__30Kry","message":"FormErrorDisplay_message__2cJI7"};